import { apiCall } from '../apiServerHelper'
import { apis } from '../apiUrls'
import {
  APPRAISAL_EXPERIMENT_COOKIE,
  APPRAISAL_VARIANT_COOKIE,
  getCookie,
  setCookie,
} from '../cookies'

export const appraisalRequest = async (options) => {
  return await apiCall(apis.APPRAISAL_REQUEST, options, 'post')
}

export const getThankYouPageData = async (thankYouPageUrl) => {
  return await apiCall(thankYouPageUrl)
}

const APPRAISAL_COOKIE_NAMES = [
  APPRAISAL_EXPERIMENT_COOKIE,
  APPRAISAL_VARIANT_COOKIE,
]

const pickAppraisalCookies = (cookieHeader = '') => {
  if (!cookieHeader) return ''

  return cookieHeader
    .split(';')
    .map((part) => part.trim())
    .filter((part) =>
      APPRAISAL_COOKIE_NAMES.some((name) => part.startsWith(`${name}=`)),
    )
    .join('; ')
}

const getSetCookieHeaders = (response) => {
  if (typeof response.headers.getSetCookie === 'function') {
    return response.headers.getSetCookie()
  }

  const single = response.headers.get('set-cookie')
  return single ? [single] : []
}

const appendAppraisalSetCookies = (res, setCookieHeaders = []) => {
  if (!res || !setCookieHeaders.length) return

  const rewritten = setCookieHeaders.map((setCookieValue) =>
    setCookieValue
      .replace(/;\s*Domain=[^;]*/gi, '')
      // Drop HttpOnly so the client can clear these after a successful submit
      .replace(/;\s*HttpOnly/gi, ''),
  )
  const existing = res.getHeader('Set-Cookie')
  const merged = [
    ...(existing ? (Array.isArray(existing) ? existing : [existing]) : []),
    ...rewritten,
  ]

  res.setHeader('Set-Cookie', merged)
}

/**
 * Sticky A/B variant via bp_appraisal_experiment_id.
 * SSR: forward cookies to CMS + proxy Set-Cookie onto the site domain.
 * Client: reuse first-party bp_appraisal_workflow_variant (no CMS/proxy call).
 */
export const getAppraisalDispersal = async (ctx = {}) => {
  try {
    if (typeof window !== 'undefined') {
      const stickyVariant = getCookie(APPRAISAL_VARIANT_COOKIE)
      if (stickyVariant) {
        return { workflow_variant: stickyVariant }
      }

      const response = await fetch(apis.APPRAISAL_DISPERSAL, {
        method: 'GET',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      })
      const data = await response.json()
      if (data?.workflow_variant) {
        setCookie(APPRAISAL_VARIANT_COOKIE, data.workflow_variant, 90)
      }
      return data
    }

    const cookie = pickAppraisalCookies(ctx.req?.headers?.cookie || '')
    const response = await fetch(apis.APPRAISAL_DISPERSAL, {
      method: 'GET',
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
        ...(cookie ? { Cookie: cookie } : {}),
      },
    })

    if (ctx.res) {
      appendAppraisalSetCookies(ctx.res, getSetCookieHeaders(response))
    }

    if (!response.ok) {
      return { workflow_variant: 'standard' }
    }

    return await response.json()
  } catch (error) {
    return { workflow_variant: 'standard' }
  }
}
